import { type ReactNode, createContext, useContext, useState } from "react";

interface ZeroStatusContextType {
  isOnline: boolean;
  setIsOnline: (online: boolean) => void;
}

const ZeroStatusContext = createContext<ZeroStatusContextType | undefined>(
  undefined,
);

export function ZeroStatusProvider({ children }: { children: ReactNode }) {
  const [isOnline, setIsOnline] = useState(false);

  const value = {
    isOnline,
    setIsOnline,
  };

  return (
    <ZeroStatusContext.Provider value={value}>
      {children}
    </ZeroStatusContext.Provider>
  );
}

export function useZeroStatus() {
  const context = useContext(ZeroStatusContext);
  if (context === undefined) {
    throw new Error("useZeroStatus must be used within a ZeroStatusProvider");
  }
  return context;
}
